import React from 'react';

import Modal from '~components/Modal';
import {BASE_MAPS} from '~components/BaseMapSelector/baseMap';
import {Project} from "~screens/Dashboard/screens/Projects/types";
import {Map} from '~screens/Dashboard/screens/ProjectsIIRSA/screens/ElementsMap/components/Map';

import styles from './styles.module.scss';

interface Props {
    project: Project;
    isOpen: boolean;
    closeModal: Function;
    className?: string;
}

function ModalContent({project, ...rest}: Props) {

    // Without a saved center the map opens on its default framing (center and zoom).
    const zoom = project.dynamicCenter ? project.dynamicCenter.zoom : undefined;

    // Always the selector's first base map (relief), whatever the viewer last picked on the Mapa page.
    return (
        <Modal title={project.name} {...rest}>
            <div className={`row full-width ${styles.containerMap}`}>
                <Map elements={[project]} zoom={zoom} baseMap={BASE_MAPS[0]}/>
            </div>
        </Modal>
    );
}

export default ModalContent;
